// Polar H10 PMD (proprietary measurement data) service helpers.
// Lets us stream raw ECG on top of the standard heart_rate profile.

export const PMD_SERVICE = "fb005c80-02e7-f387-1cad-8acd2d8df0c8";
export const PMD_CONTROL = "fb005c81-02e7-f387-1cad-8acd2d8df0c8";
export const PMD_DATA = "fb005c82-02e7-f387-1cad-8acd2d8df0c8";

const PMD_ECG = 0x00;

export const ECG_RATE_HZ = 130;

export const START_ECG: Uint8Array<ArrayBuffer> = new Uint8Array([
  0x02,
  PMD_ECG,
  0x00,
  0x01,
  0x82,
  0x00,
  0x01,
  0x01,
  0x0e,
  0x00,
  0x02,
  0x01,
  0x00,
  0x00,
]);

export const STOP_ECG: Uint8Array<ArrayBuffer> = new Uint8Array([0x03, PMD_ECG]);

/** Fixed-size circular buffer of int24 ECG samples. */
export class EcgRing {
  readonly size: number;
  readonly buf: Int32Array;
  head = 0;
  filled = false;

  constructor(size: number) {
    this.size = size;
    this.buf = new Int32Array(size);
  }

  push(value: number): void {
    this.buf[this.head] = value;
    this.head = (this.head + 1) % this.size;
    if (this.head === 0) this.filled = true;
  }

  extents(): [number, number] {
    const length = this.filled ? this.size : this.head;
    if (length === 0) return [Number.NaN, Number.NaN];
    let min = Infinity;
    let max = -Infinity;
    for (let index = 0; index < length; index++) {
      const value = this.buf[index] ?? 0;
      if (value < min) min = value;
      if (value > max) max = value;
    }
    return [min, max];
  }
}

/** Decode a PMD ECG notification frame and push its samples into the ring. */
export function decodeEcgFrame(view: DataView, ring: EcgRing): number {
  if (view.byteLength < 10) return 0;
  const measType = view.getUint8(0);
  const frameType = view.getUint8(9);
  if (measType !== PMD_ECG || frameType !== 0x00) return 0;
  let count = 0;
  for (let index = 10; index + 3 <= view.byteLength; index += 3) {
    let value =
      view.getUint8(index) | (view.getUint8(index + 1) << 8) | (view.getUint8(index + 2) << 16);
    if (value & 0x800000) value -= 0x1000000;
    ring.push(value);
    count++;
  }
  return count;
}
